module.exports = __webpack_public_path__ + "img/service-flow-company_m.1a969edd.svg";